import { makeStyles } from "@material-ui/core/styles";
import { green, grey } from "@material-ui/core/colors";

const useMessageInputStyles = makeStyles((theme) => ({
  mainWrapper: {
    backgroundColor: theme.mode === 'dark' ? '#111827' : 'transparent', // ✅ USA TEMA - Fondo oscuro para dark mode
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "12px 16px 16px 16px",
    marginTop: "8px",
    position: "relative",
  },

  /** Vista móvil (sm-): una sola fila, campo de texto con flex 1 */
  newMessageBoxCompact: {
    padding: "8px 8px",
    flexWrap: "nowrap",
    alignItems: "flex-end",
    gap: 4,
  },
  messageInputWrapperGrow: {
    flex: 1,
    minWidth: 0,
    marginRight: 4,
  },
  mobileComposerFab: {
    flexShrink: 0,
    backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: theme.mode === 'dark' ? '#2563eb' : '#bbdefb',
    },
  },
  newMessageBox: {
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
    width: "100%",
    display: "flex",
    padding: "10px 12px",
    alignItems: "center",
    borderRadius: "24px",
    boxShadow: theme.mode === 'dark'
      ? '0 4px 12px rgba(0,0,0,0.3), 0 2px 4px rgba(0,0,0,0.2)'
      : '0 4px 12px rgba(0,0,0,0.1), 0 2px 4px rgba(0,0,0,0.08)',
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e5e7eb'}`,
    transition: "all 0.2s ease",
    "&:focus-within": {
      boxShadow: theme.mode === 'dark'
        ? '0 6px 16px rgba(0,0,0,0.4), 0 4px 6px rgba(0,0,0,0.3)'
        : '0 6px 16px rgba(0,0,0,0.15), 0 4px 6px rgba(0,0,0,0.1)',
      borderColor: theme.palette.primary.main,
    },
  },

  messageInputWrapper: {
    padding: 0,
    marginRight: 8,
    backgroundColor: "transparent",
    display: "flex",
    borderRadius: 0,
    flex: 1,
    position: "relative", // ✅ Para el posicionamiento del dropdown
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    backgroundColor: "transparent", // ✅ NUEVO: Fondo transparente
    color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA - Color del texto
    "&::placeholder": {
      color: theme.mode === 'dark' ? '#9ca3af' : '#6b7280', // ✅ USA TEMA - Color del placeholder
    },
  },

  sendMessageIcons: {
    color: theme.mode === 'dark' ? '#d1d5db' : 'grey', // ✅ USA TEMA
  },

  ForwardMessageIcons: {
    color: grey[700],
    transform: 'scaleX(-1)'
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.mode === 'dark' ? '#374151' : '#eee', // ✅ USA TEMA
    borderTop: `1px solid ${theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.12)'}`, // ✅ USA TEMA
  },

  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e8e8e8'}`, // ✅ USA TEMA
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  // ✅ CORRECTO: Estilos para el dropdown de respuestas rápidas - UX VISIBLE Y PROFESIONAL
  quickMessagesDropdown: {
    backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff', // ✅ USA TEMA
    border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`, // ✅ USA TEMA
    borderRadius: "8px",
    boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.15)', // ✅ USA TEMA
    zIndex: 9999,
    maxHeight: "250px",
    overflow: "auto",
    minHeight: "40px",
    padding: "8px 0",
    // ✅ FORZAR VISIBILIDAD DEL CONTENIDO
    "& .MuiAutocomplete-listbox": {
      padding: "0",
      maxHeight: "none",
        "& .MuiAutocomplete-option": {
          padding: "12px 16px",
          fontSize: "14px",
          minHeight: "44px",
          lineHeight: "1.4",
          borderBottom: `1px solid ${theme.mode === 'dark' ? '#374151' : '#f0f0f0'}`, // ✅ USA TEMA
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          color: theme.mode === 'dark' ? '#f9fafb' : '#1f2937', // ✅ USA TEMA - Color del texto
          "&:last-child": {
            borderBottom: "none"
          },
          "&:hover": {
            backgroundColor: theme.mode === 'dark' ? '#374151' : '#f8f9fa', // ✅ USA TEMA
          },
          "&.Mui-focused": {
            backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd', // ✅ USA TEMA
          },
          "&.Mui-selected": {
            backgroundColor: theme.mode === 'dark' ? '#3b82f6' : '#e3f2fd', // ✅ USA TEMA
            fontWeight: "500"
          }
        }
    },
    // ✅ ESTILOS ADICIONALES PARA MEJOR VISIBILIDAD
    "& .MuiAutocomplete-paper": {
      backgroundColor: theme.mode === 'dark' ? '#1f2937' : '#ffffff', // ✅ USA TEMA
      boxShadow: theme.mode === 'dark' ? '0 4px 12px rgba(0,0,0,0.5)' : '0 4px 12px rgba(0,0,0,0.15)', // ✅ USA TEMA
      borderRadius: "8px",
      border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}` // ✅ USA TEMA
    }
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },
}));

export default useMessageInputStyles;
